import { exists } from '@/api'

export interface BatchReserveUserListCondition {
  dateFrom: string
  dateTo: string
  dateType: string
  branchCode: string
  branchType: string
  reserveStatus: string
  outputOrder: string
  hasLendable: boolean
  lendableNumber: string
  lendableType: string
  reserveMethod: string
  reserveContactMethod: string
  materialFormatFrom: string
  materialFormatTo: string
}

export function BatchReserveUserListConditionFromJSON(
  json: any
): BatchReserveUserListCondition {
  const _json = JSON.parse(json)

  return {
    dateFrom: exists(_json, 'date_from') ? _json.date_from : '',
    dateTo: exists(_json, 'date_to') ? _json.date_to : '',
    dateType: exists(_json, 'date_type') ? _json.date_type : '1',
    branchCode: exists(_json, 'branch_code') ? _json.branch_code : '',
    branchType: exists(_json, 'branch_type') ? _json.branch_type : '1',
    reserveStatus: exists(_json, 'reserve_status') ? _json.reserve_status : '1',
    outputOrder: exists(_json, 'output_order') ? _json.output_order : '1',
    hasLendable: exists(_json, 'has_lendable') ? _json.has_lendable : false,
    lendableNumber: exists(_json, 'lendable_number')
      ? String(_json.lendable_number)
      : '',
    lendableType: exists(_json, 'lendable_type') ? _json.lendable_type : '1',
    reserveMethod: exists(_json, 'reserve_method') ? _json.reserve_method : '',
    reserveContactMethod: exists(_json, 'reserve_contact_method')
      ? _json.reserve_contact_method
      : '',
    materialFormatFrom: exists(_json, 'material_format_from')
      ? _json.material_format_from
      : '',
    materialFormatTo: exists(_json, 'material_format_to')
      ? _json.material_format_to
      : ''
  }
}
